import { Typography } from "@drone-js/core";
import { Fragment } from "react";
import { useStaticDataAtomValue } from "../../staticDataAtom";
import { NightlyRateController } from "./NightlyRateController";

export const ManualPriceController = () => {
    const {
        cmsData: {
            pricing: { nightlyRate, setYourRate },
        },
    } = useStaticDataAtomValue();

    return (
        <Fragment>
            <Typography variant="body-default-strong">{setYourRate}</Typography>
            <NightlyRateController label={nightlyRate} dataElementName="nightly-rate" />
        </Fragment>
    );
};
